import { apiCall } from "./Interceptor";

const SPECIFICATION_ALL = "/specification/getAll/public";

const getAllSpecificationTypes = async () => {
    const response = await apiCall.get(SPECIFICATION_ALL);
    return response;
}

export default {
    getAllSpecificationTypes,
};
